import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";

export type UnsavedChangesDialogModel = {
};

@Component({
  templateUrl: "./unsaved-changes-dialog.template.pug",
})
export class UnsavedChangesDialogComponent extends DialogComponent<UnsavedChangesDialogModel, string>
  implements UnsavedChangesDialogModel {
  public static showUnsavedChangesModal(dialogService: DialogService): Observable<string> {
    return dialogService.addDialog(UnsavedChangesDialogComponent, {}, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  constructor(
    public dialogService: DialogService,
  ) {
    super(dialogService);
    this.result = "cancel";
  }

  closeDialog(result: string) {
    this.result = result;
    this.close();
  }
}
